import { createFileRoute } from '@tanstack/react-router'
import { UsersListPage } from '@/pages/Users/UsersListPage'

export const Route = createFileRoute('/_authenticated/users')({
  component: UsersListPage,
})
